/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../generators/javascript.js';
$['__chunk_javascript'] = exports;
